import { IAction, isType } from '@zaibot/fsa';
import SortingMethod from '../filter/SortingMethod';

import CATEGORIES from './actions/CATEGORIES';
import HIDE from './actions/HIDE';
import KINDS from './actions/KINDS';
import ORIGINS from './actions/ORIGINS';
import PARTICIPANTGROUPS from './actions/PARTICIPANTGROUPS';
import PARTICIPANTS from './actions/PARTICIPANTS';
import REMOVEALL from './actions/REMOVEALL';
import REMOVEALL_ALL_CATEGORIES from './actions/REMOVEALL_ALL_CATEGORIES';
import REMOVEALL_ALL_GROUPS from './actions/REMOVEALL_ALL_GROUPS';
import REMOVE_ALL_KINDS from './actions/REMOVE_ALL_KINDS';
import REMOVE_ALL_ORIGINS from './actions/REMOVE_ALL_ORIGINS';
import REMOVE_ALL_PARTICIPANTS from './actions/REMOVE_ALL_PARTICIPANTS';
import SHOW from './actions/SHOW';
import SORT from './actions/SORT';
import TERM from './actions/TERM';
import Kind from './Kind';
import Origin from './Origin';
import Status from './Status';
import STATUSES from './actions/STATUSES';
import FACTIONGROUPS from './actions/FACTIONGROUPS';
import REMOVE_ALL_FACTIONS from './actions/REMOVE_ALL_FACTIONS';
import REMOVE_ALL_STATUSES from './actions/REMOVE_ALL_STATUSES';
import REMOVE_ALL_STATUSES_AND_FACTIONS from './actions/REMOVE_ALL_STATUSES_AND_FACTIONS';

interface IState {
  visible: boolean;
  categories: number[];
  participants: string[];
  participantgroups: number[];
  factiongroups: number[];
  kinds: Kind[];
  origins: Origin[];
  statuses: Status[];
  sorting: SortingMethod;
  searchTerm: string;
  userId: string;
}
const emptyState: IState = { visible: false, categories: [] as number[], kinds: [] as Kind[], origins: [] as Origin[], statuses: [] as Status[], participants: [] as string[], participantgroups: [] as number[], factiongroups: [] as number[],sorting: 'createdAsc', searchTerm: '', userId: '' };
export const selector = (state: any) => state.filter as IState;

export const reducer = (state = emptyState, action: IAction) => {
    if (isType(action, SHOW)) {
      return { ...state, visible: true };
    }
    if (isType(action, HIDE)) {
      return { ...state, visible: false };
    }
    if (isType(action, TERM)) {
      return { ...state, searchTerm: action.payload.searchTerm };
    }
    if (isType(action, SORT)) {
      return { ...state, sorting: action.payload.sorting };
    }
    if (isType(action, CATEGORIES)) {
      return { ...state, categories: action.payload.categories };
    }
    if (isType(action, KINDS)) {
      return { ...state, kinds: action.payload.kinds };
    }    
    if (isType(action, ORIGINS)) {
      return { ...state, origins: action.payload.origins };
    }   
    if (isType(action, STATUSES)) {
      return { ...state, statuses: action.payload.statuses };
    }      
    if (isType(action, PARTICIPANTS)) {
      return { ...state, participants: action.payload.participants };
    }      
    if (isType(action, PARTICIPANTGROUPS)) {
      return { ...state, participantgroups: action.payload.participantgroups };
    }   
    if (isType(action, FACTIONGROUPS)) {
      return { ...state, factiongroups: action.payload.factiongroups };
    }   
    if (isType(action, REMOVEALL)) {
      return { ...state, 
          searchTerm: '',
          categories: [],
          kinds: [],
          origins: [],
          participants: undefined,
          participantgroups: undefined,
      };
    }   
    if (isType(action, REMOVE_ALL_STATUSES_AND_FACTIONS)) {
      return { ...state, 
          statuses: [],
          factiongroups: undefined,
      };
    }     
    if (isType(action, REMOVE_ALL_STATUSES)) {
      return { ...state, 
          statuses: [],
      };
    }      
    if (isType(action, REMOVE_ALL_KINDS)) {
      return { ...state, 
          kinds: [],
      };
    }      
    if (isType(action, REMOVE_ALL_ORIGINS)) {
      return { ...state, 
          origins: [],
      };
    }   
    if (isType(action, REMOVE_ALL_PARTICIPANTS)) {
      return { ...state, 
        participants: undefined,
      };
    }      
    if (isType(action, REMOVEALL_ALL_GROUPS)) {
      return { ...state, 
        participantgroups: undefined,
      };
    }    
    if (isType(action, REMOVE_ALL_FACTIONS)) {
      return { ...state, 
        factiongroups: undefined,
      };
    }          
    if (isType(action, REMOVEALL_ALL_CATEGORIES)) {
      return { ...state, 
        categories: [],
      };
    }         
    return state;
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/filter/reducer.tsx